// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_mc-2";
export var interactiveWrapper = "_mc-0";
export var shippingHoverPreview = "_mc-4";
export var summaryBadgeTrigger = "_mc-1";
export var widgetHoverPreviewList = "_mc-3";
export var widgetPreviewScale = "_mc-5";